import { SCol, SRow } from '@avalara/skylab-sdk/react';
import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import { IossCurrencies } from '../../../../../shared/types/currency';
import conf from '../../../../conf';
import { embeddedViewRequested } from '../../../../lib/helpers';
import EmptyCartPanel from '../../../buy-flow/empty-cart-panel';
import ExternalLink from '../../../external-link';
import OfferBox from '../../box';
import OfferDetails from '../../offer-details';
import NextButton from '../shared/next-button';
import IossOfferPlan from './ioss-offer-plan';
const CurrencySelect = styled.select `width: 100px;`;
const IossPlanSelect = ({ plans }) => {
    const [selectedCurrency, selectCurrency] = useState('GBP');
    const selectedPlan = plans === null || plans === void 0 ? void 0 : plans.find(plan => plan.currency && plan.currency === selectedCurrency);
    const changeCurrency = e => selectCurrency(e.target.value);
    const isEmbedded = embeddedViewRequested();
    return (React.createElement(Fragment, null,
        React.createElement(SRow, null,
            React.createElement(SCol, { "data-ref": 'buy.plan-select.ioss.column-container', span: isEmbedded ? '' : 'md-7 9', className: isEmbedded ? '' : 'pad-bottom-none' },
                React.createElement(OfferBox, { isEmbedded: isEmbedded, className: 'pad-all-sm' },
                    React.createElement("div", { className: 'margin-left-sm' },
                        React.createElement("h1", null, "Get started in four easy steps"),
                        React.createElement("p", null,
                            'Already have an account? ',
                            React.createElement(ExternalLink, { href: conf.AA_URL }, "Contact your account manager"),
                            ' to buy the Avalara IOSS Solution'),
                        React.createElement("label", { htmlFor: 'currency-select' }, "Currency"),
                        React.createElement(CurrencySelect, { id: 'currency-select', "data-ref": 'ioss.currency-select', onChange: changeCurrency, value: selectedCurrency }, IossCurrencies.map(currency => React.createElement("option", { key: currency, value: currency }, currency)))),
                    React.createElement("div", { className: 'margin-top-lg margin-bottom-xl' },
                        React.createElement(IossOfferPlan, null)),
                    React.createElement(NextButton, { selectedPlanName: (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name) || '' }))),
            !isEmbedded && React.createElement(SCol, { span: 'md-5 3' },
                React.createElement(EmptyCartPanel, null))),
        !isEmbedded && React.createElement(SRow, null,
            React.createElement(SCol, { span: 'md-7 9' },
                React.createElement(OfferDetails, null)))));
};
export default IossPlanSelect;
